import { render, staticRenderFns } from "./popupSettingPayroll.vue?vue&type=template&id=1b63c99e"
import script from "./popupSettingPayroll.vue?vue&type=script&lang=js"
export * from "./popupSettingPayroll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports